import axios from 'axios';

export function getFAQs({ courseId, searchQuery = '' }) {
  return (dispatch) => {
    return axios
      .get('/api/faqs/getFAQs', { params: { courseId, searchQuery } })
      .then((res) => res.data);
  };
}

export function addFAQ(faq) {
  return (dispatch) => {
    return axios.post('/api/faqs/addFAQ', faq);
  };
}

export function updateFAQ(faq) {
  return (dispatch) => {
    return axios.put(`/api/faqs/updateFAQ/${faq._id}`, faq);
  };
}

export function deleteFAQ(faqId) {
  return (dispatch) => {
    return axios.delete(`/api/faqs/deleteFAQ/${faqId}`);
  };
}

export function updateFAQOrders(data) {
  return (dispatch) => {
    return axios.put('api/faqs/updateFAQOrders', data);
  };
}
